import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  default: {
    detail: {
      id: null,
      email: '',
      eid: '',
      birthday: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      gender: '',
      firstName: '',
      lastName: '',
      nickName: '',
      phoneDay: '',
      phoneHome: '',
      phoneCell: '',
      isAllowTextMessages: null,
      organization_id: null,
      currentorganization_id: null,
      timezone_id: null,
      organization: '',
      password: '',
      password2: '',
    },
    organizations: [],
  },
  defaultNote: {
    id: null,
    subject: null,
    note: null,
    user_id: null,
    createdby_id: null,
    priority: 0,
    is_complete: false,
    date_complete: null,
    created_at: null,
  },
  token: storage.session.getItem(types.STORE_TOKEN)
    ? JSON.parse(storage.session.getItem(types.STORE_TOKEN))
    : null,
  profile: storage.session.getItem(types.STORE_PROFILE)
    ? JSON.parse(storage.session.getItem(types.STORE_PROFILE))
    : {
        id: null,
        name: null,
        email: null,
      },
  user: null,
  users: [],
  foundUsers: [],
  roles: [],
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'asc',
        sortBy: null,
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  isChecked: false,
  note: null,
  notes: [],
})
